import React, { useState, useEffect, useReducer } from 'react';
import axiosInstance from '../../axios';
import { useParams } from 'react-router-dom';
//MaterialUI
import CssBaseline from '@material-ui/core/CssBaseline';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import ThumbDownIcon from '@material-ui/icons/ThumbDown';

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    commentSection: {
        border: '1px solid',
    },
    commentBody: {
		fontSize: '16px',
		textAlign: 'left',
        marginLeft:'5%',
        marginTop: '1%',
	},
    userName: {
        fontSize: '18px',
        textAlign: 'left',
        marginRight: '85%',
    },
    buttons: {
        marginLeft: '5%',
        marginRight: '5%',
        marginTop: '-3%',
        marginBottom: '10%',
    }
}));

export default function Post() {
    const {slug} = useParams();
    const classes = useStyles();

    const [data, setData] = useState({posts:[]});
    const [postComments, setComments] = useState([]);

    const style = {fontSize:'1.2em', marginTop:'2%', marginRight:'90%'}

    useEffect(() => {
        axiosInstance.get(slug).then((res)=>{
            setData({posts: res.data});
            // console.log(res.data)
            // console.log({posts: res.data})
        })
    },[setData])

    useEffect(() => {
        axiosInstance.get(`comments/${slug}`).then((res)=>{
            // console.log(res.data)
            setComments(res.data)
            res.data.map((comment)=>{
                console.log(comment)
            })
            postComments.map((comment)=>{
                console.log(comment)
            })
        })
    },[setComments])


    const createMarkUp = () => {
        return {__html: data.posts.content};
    }

    const likeThePost = () => {
        axiosInstance.put(slug + '/', {
            likes: data.posts.likes+1,
        }).then((res)=>{
            console.log(res)
            window.location.reload();
        })
    }

    return (
        <Container component="main" maxWidth="md">
            <CssBaseline />
            <div className={classes.paper}></div>
            <div className={classes.hereContent}>
                <Container maxWidth="md">
                    <Typography
                        variant="h5"
                        align="center"
                        color="textSecondary"
                        paragraph
                        >
                    <div
                        dangerouslySetInnerHTML={createMarkUp()}>
                    </div>
                    </Typography>
                </Container>
            </div>
            <div>
                <Container maxWidth='small'>
                    <div className={classes.paper}></div>
                    <Typography
                        variant='h5'
                        align='center'
                        color='textSecondary'
                        heading>
                        <Button
                            href='#'
                            color='primary'
                            variant='outlined'
                            className={classes.buttons}
                            onClick={()=>likeThePost()}
                        >
                            <ThumbUpAltIcon />
                        <p >{data.posts.likes}</p>
                        </Button>
                        <Button
                            href='#'
                            color='secondary'
                            variant='outlined'
                            className={classes.buttons}
                            // onClick={}
                        >
                            <p>{data.posts.dislikes}</p>
                            <ThumbDownIcon />
                        </Button>
                    </Typography>
                </Container>
            </div>
            <div className={classes.hereContent}>
                <Container maxWidth="md">
                    <Typography
                        variant='h5'
                        align='center'
                        color='textPrimary'
                        heading>
                            Comments
                    </Typography>
                    <Typography
                        variant='h5'
                        align='center'
                        color='textSecondary'
                        paragraph>
                        <div className={classes.commentSection}>
                        {postComments.map((comment)=>{
                            return (
                                <div>
                                    <p className={classes.userName}>&#9924;{comment.get_username}</p>
                                    <p className={classes.commentBody}>{comment.body}</p>
                                    <hr/>
                                </div>
                            )
                        })}
                        </div>
                    </Typography>
                </Container>
            </div>
        </Container>
    )
}